import { render } from "./CustomerProposalValidationModal.vue?vue&type=template&id=796ab492&scoped=true&ts=true&lang=pug"
import script from "./CustomerProposalValidationModal.vue?vue&type=script&lang=ts"
export * from "./CustomerProposalValidationModal.vue?vue&type=script&lang=ts"

import "./CustomerProposalValidationModal.vue?vue&type=style&index=0&id=796ab492&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-796ab492"]])

export default __exports__